import React from "react";

import CarSearchFiltersForm from "./CarSearchFiltersForm";

const CarSearchForm: React.FC = () => {
    return <CarSearchFiltersForm variant="homepage" />;
};

export default CarSearchForm;
